module.exports = __webpack_public_path__ + "6f63eff3e9ce40e734fcd432581aa2bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileApp/mobile-app.png
// module id = 1333
// module chunks = 47